import { buildWidthCssTransition } from './tile-motion';

export const ANIMATION_DURATION = 0.35;
export const PANEL_NUDGE_DURATION = 0.2;
export const TILE_REFLOW_DURATION = 0.4;

export const TILE_TRANSITION = {
    duration: ANIMATION_DURATION,
    ease: 'easeOut',
} as const;

export const TILE_EXIT_VARIANT = 'tile-exit';

export const TILE_WIDTH_CSS_TRANSITION = buildWidthCssTransition(TILE_REFLOW_DURATION);

export const LARGE_SCREEN_BREAKPOINT = '(min-width: 1920px)';
export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

export const MAIN_TILE_ID = '__main__';
